
    export default {
        name: 'SpringSaleHero',
        props: {
            link: {
                type: String,
                default: '',
            },
        },
        methods: {
            handleClick() {
                if (!this.link) return
                // Use Nuxt router for internal links, window.location for external
                if (this.link.startsWith('http')) {
                    window.open(this.link, '_blank')
                } else {
                    this.$router.push(this.link)
                }
            },
        },
    }
